import React from 'react';
import { formatMoney } from 'utils/currencyFormat';

const NumberField = ({
  name,
  inputRef,
  value,
  onChange,
  className,
  placeholder,
  decimalCount = 0,
  readOnly = false,
  id = ''
}) => {
  return (
    <input
      ref={inputRef}
      name={name}
      className={className}
      placeholder={placeholder}
      onChange={onChange}
      value={formatMoney(value, decimalCount)}
      readOnly={readOnly}
      id={id}
    ></input>
  );
};
export default NumberField;
